module.exports = __webpack_public_path__ + "img/warning.36d166bc.png";